import AboutSubPage from "@/pages/about/components/AboutSubPage";

export default function ManagementEsPage() {
  return (
    <AboutSubPage
      heroImageSrc="https://net-basis.net/Bilder/christof-guenther-ict-management-dach.webp"
      texts={{
        title: "Dirección",
        heroClaimLine1: "¡Impulsados por la experiencia!",
        heroClaimLine2: "",
        bottomClaim: "NetBasis International - drive to excellence with excellent drivers !",
      }}
      metaTitle="Dirección – Christof Günther | NetBasis International"
      metaDescription="Christof Günther lidera el desarrollo de negocios B2B en la región DACH como socio estratégico y propietario con más de 30 años de experiencia TIC."
      metaOgUrl="https://net-basis.net/es/sobre-nosotros/direccion"
    >
      <div className="flex flex-col md:flex-row md:items-start gap-8 md:gap-12">
        <div className="flex-shrink-0 flex justify-center md:justify-start">
          <div className="w-48 md:w-52 h-auto overflow-hidden rounded-lg border border-background-200">
            <img loading="lazy"
              src="https://net-basis.net/Bilder/CG-Foto.jpg"
              alt="Christof Günther"
              title="Christof Günther - NetBasis International"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        <div className="flex-1 space-y-4 text-foreground-950 leading-relaxed text-sm md:text-base">
          <h1 className="text-sm md:text-base font-semibold text-foreground-950 font-sans">
            Christof Günther: Fundador, propietario y su mente estratégica para un desarrollo de negocios B2B exitoso en la región DACH.
          </h1>
          <p>
            <strong className="text-primary-600">NetBasis International</strong> fue fundada por él en Düsseldorf a principios de 2008 y desde entonces ha sido gestionada por su propietario.
          </p>
          <p>Con más de 30 años de profunda experiencia internacional en el sector de las TIC, ayuda de manera eficaz a los fabricantes extranjeros a abrirse camino con éxito en nuevos mercados con sus productos y soluciones tecnológicas. Su enfoque profesional se centra deliberadamente en todas las áreas clave del desarrollo de negocios estratégico y operativo. En estrecha colaboración, desarrolla conceptos integrales y de futuro para la entrada al mercado para y con sus socios comerciales, apoyándolos de forma fiable en la ejecución práctica y la gestión orientada de todos sus proyectos.</p>
          <p>Además, pone su profundo conocimiento del mercado y sus amplias perspectivas del sector a disposición de las empresas interesadas a través de mandatos de consultoría especializados, así como mediante capacitaciones a medida y sesiones de coaching individual.</p>
          <p>Antes de fundar <strong className="text-primary-600">NetBasis International</strong>, el Sr. Günther ocupó durante muchos años puestos de responsabilidad ejecutiva —incluyendo los de director de sucursal, director de ventas y director de exportación— en empresas medianas de telecomunicaciones e informática con operaciones en toda Europa y a nivel mundial. Esta larga experiencia en gestión constituye la base sólida para el éxito sostenible de sus proyectos internacionales.</p>
        </div>
      </div>
    </AboutSubPage>
  );
}